export default __webpack_public_path__ + "static/media/arrow-up.036fb166.svg";